import React, { useEffect, useState } from 'react'
import { FaMusic, FaPlus } from 'react-icons/fa'
import { useMusic } from '../context/MusicContext'
import { useParams } from 'react-router-dom'

const SongList = () => {
  const {
    selectedArtist,
    artistSongs,
    isArtistLoading,
    setFallbackPlaylist,
    clearUserPlaylist,
    addToUserPlaylist,
    currentTrack,
    playSong,
    API_URL,
    handleArtistSelect,
  } = useMusic()

  const [buttonPressedKey, setButtonPressedKey] = useState(null)

  const { artistName } = useParams()

  useEffect(() => {
    handleArtistSelect(artistName)
    console.log('artistName', artistName)
  }, [artistName, handleArtistSelect]) // Runs only when artistName changes

  const onSongSelect = (selectedSong, index) => {
    // clearUserPlaylist()
    setFallbackPlaylist(artistSongs)
    playSong(selectedSong, index)
  }

  return (
    <>
      {isArtistLoading && (
        <div className="page-status" role="status" aria-live="polite">
          Laddar låtar...
        </div>
      )}
      {!isArtistLoading && artistSongs.length === 0 && (
        <div className="page-status" role="status">
          Inga låtar hittades.
        </div>
      )}
      <ul className="song-list">
        {artistSongs.map((song, index) => (
          <li
            key={song.title}
            className={`song-item ${
              currentTrack?.title === song.title ? 'active' : ''
            }`}
            onClick={() => {
              console.log('Selected a song')
              console.log('song: ', song)
              console.log('index: ', index)
              onSongSelect(song, index)
            }}
          >
            <div className="song-item-content">
              <button
                type="button"
                className={`add-to-playlist-button ${buttonPressedKey === song.title ? 'clicked' : ''}`}
                title="Add to playlist"
                aria-label="Add to playlist"
                onClick={(e) => {
                  e.stopPropagation()
                  addToUserPlaylist(song)
                  setButtonPressedKey(song.title)
                  // console.log('User clicked button "add-to-playlist-button"')
                  setTimeout(() => {
                    setButtonPressedKey(null)
                    // console.log('button is resetet to normal look')
                  }, 300)
                }}
              >
                <FaPlus size={18} />
              </button>
              <img
                src={`${API_URL}/artist/${selectedArtist}/cover/${song.title}`}
                alt="Song cover"
                className="song-cover"
                onError={(e) => {
                  e.target.style.display = 'none'
                  // Just add a class to the parent to show the icon
                  e.target.parentNode.classList.add('show-fallback-icon')
                }}
              />
              {/* Add the fallback icon that will be shown when needed */}
              <span className="fallback-icon" style={{ display: 'none' }}>
                <FaMusic size={40} />
              </span>
              <span>{song.title}</span>
              {/* <span>if (item.type === 'music') return `music|${item.artist}|${item.title}`</span> */}
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}

export default SongList
